module.exports = __webpack_public_path__ + "media/22.78d8c004.mp3";